export default __webpack_public_path__ + "static/media/img_chart_grade_B0.5ba2abdf35faad082b33c4b844507174.svg";